export default __webpack_public_path__ + "static/media/secondary_check_icon.0d686d23.svg";